import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from  '../store/index'
import bus from '../services/EventBus';

import Startpage from '../components/Startpage.vue';
import AddPost from '../components/posts/AddPostPage.vue';
import Login from '../components/user/LoginPage.vue';
import Registration from '../components/user/RegistrationPage.vue';
import Intro from '../components/user/intro/IntroPage.vue';
import Dashboard from '../components/user/DashboardPage.vue';
import Blogs from '../components/blogs/BlogsPage.vue';
import SearchPage from '../components/blogs/SearchPage.vue';
import UserBlogs from '../components/user/blogs/UserBlogsListPage.vue';
import CreateBlog from '../components/user/blogs/CreateBlogPage.vue';
import SharePage from '../components/posts/SharePage.vue';
import BlogPage from '../components/blogs/BlogPage.vue';
import SyncTumblr from '../components/user/tumblr/SyncTublrPage.vue';
import EditBlog from '../components/user/blogs/UserBlogEdit.vue';
import Profile from '../components/user/ProfilePage.vue';
import AboutPage from '../components/AboutPage.vue';
import TermsPage from '../components/TermsPage.vue';
import ForgotPwPage from '../components/user/ForgotPwPage.vue';
import AccountDeleted from '../components/user/AccountDeletedPage.vue';
import Charts from '../components/blogs/BlogsCharts.vue';
import Messenger from '../components/messenger/MessengerPage';
import MessengerDetail from '../components/messenger/MessengerDetailPage';
import FollowedBlogsPage from '../components/user/FollowedBlogsPage';


Vue.use(Router)
Vue.use(Meta)



const router = new Router({
    mode: 'history',
        routes: [
            {
                path: '/start',
                name: 'Startpage',
                component: Startpage,
                meta: {bgImage: true}
            },
            {
                path: '/what-is-pimblr',
                name: 'WhatIsPimblr',
                component: AboutPage,
                meta: {bgImage: true}
            },
            {
                path: '/terms-and-conditions',
                name: 'TermsConditions',
                component: TermsPage,
                meta: {bgImage: true}
            },
            {
              path: '/register',
              name: 'Registration',
              component: Registration,
              meta: {bgImage: true}
            },

            {
                path: '/forgotpw',
                name: 'ForgotPassword',
                component: ForgotPwPage,
                meta: {bgImage: true}
            },
            {
                path: '/retrivepassword/:key',
                name: 'RetrievePassword',
                component: ForgotPwPage,
                meta: {bgImage: true}
            },

            {
                path: '/intro',
                name: 'Intro',
                component: Intro
            },
            {
                path: '/login',
                name: 'Login',
                component: Login,
                meta: {bgImage: true}
            },
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: Dashboard
            },
            {
                path: '/addPost',
                name: 'Add',
                component: AddPost
            },
            {
                path: '/blogs',
                name: 'Blogs',
                component: Blogs
            },
            {
                path: '/charts',
                name: 'Charts',
                component: Charts
            },
            {
                path: '/createBlog',
                name: 'CreateBlog',
                component: CreateBlog
            },
            {
                path: '/editBlog/:blogUrl',
                name: 'EditBlog',
                component: EditBlog
            },

            // Messaging
            {
                path: '/messenger',
                name: 'Messenger',
                component: Messenger
            },
            {
                path: '/messenger/blog/:blogUrl',
                name: 'MessageToBlog',
                component: MessengerDetail
            },
            {
                path: '/messenger/blog/:blogUrl/user/:userId',
                name: 'MessageToUserFromBlog',
                component: MessengerDetail
            },
            {
                path: '/messenger/chat/:conversationId',
                name: 'MessengerDetail',
                component: MessengerDetail
            },

            // Blog Page
            {
                path: '/blog/:blogUrl',
                name: 'BlogPage',
                component: BlogPage
            },
            {
                path: '/blog/:blogUrl/video/:videoId',
                name: 'BlogPageVideo',
                component: BlogPage
            },
            {
                path: '/profile',
                name: 'Profile',
                component: Profile
            },
            {
              path: '/profile/following',
              name: 'FollowedBlogs',
              component: FollowedBlogsPage
            },
            {
              path: '/account-deleted',
              name: 'AccountDeleted',
              component: AccountDeleted
            },
            {
                path: '/myblogs/synctumblr',
                name: 'SyncTumblr',
                component: SyncTumblr
            },

            {
                path: '/myblogs',
                name: 'MyBlogs',
                component: UserBlogs
            },
            {
                path: '/search/:query',
                name: 'Search',
                component: SearchPage
            },


            // SharePage
            {
                path: '/share',
                name: 'Share',
                component: SharePage
            },


            {
              path: '/',
                redirect: '/start'
            }
        ]
    }
);


router.beforeEach((to, from, next)=>{

    let bcl = document.body.classList;

    if(to.matched.some(record => record.meta.bgImage)){
        if(!bcl.contains('bgImage')) bcl.add('bgImage');
    } else {
        if(bcl.contains('bgImage')) bcl.remove('bgImage');
    }

    bus.$emit('track.click', {
        path: to.path,
        title: to.name
    });



     next();

});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js